<template>
  <app-dialog v-model="dialogIsOpen" :title="currentTitle" :max-width="maxWidth" @click:outside="closeSignUpDialog">
    <component :is="formSteps[currentStep].component" v-bind="{ ...formSteps[currentStep].props }" @next-step="onNextStep" @prev-step="onPrevStep" />
  </app-dialog>
</template>

<script>
import SignUpForm from '@/components/authentication/SignUpForm.vue'
import OTPForm from '@/components/authentication/OTPForm.vue'
import ReferrerForm from '@/components/authentication/ReferrerForm.vue'
import CreatePasswordForm from '@/components/authentication/CreatePasswordForm.vue'
import ReferralForm from '@/components/authentication/ReferralForm.vue'
import AccountCreationSuccessful from '@/components/authentication/AccountCreationSuccessful.vue'
import ReferrerSignupSuccessful from '@/components/authentication/ReferrerSignupSuccessful.vue'
import { localeHelper } from '@/utils'

export default {
  components: {
    SignUpForm,
    OTPForm,
    ReferrerForm,
    CreatePasswordForm,
    ReferralForm,
    AccountCreationSuccessful
  },

  props: ['value'],

  data() {
    return {
      currentStep: 0,
      maxWidth: '450',
      formSteps: [
        { component: SignUpForm, title: localeHelper.getMessage('label.signUp') },
        { component: OTPForm, title: localeHelper.getMessage('label.enterOtp'), props: { otpType: 'REGISTER' } },
        { component: ReferrerForm, title: localeHelper.getMessage('label.userDetails') },
        { component: ReferralForm, title: localeHelper.getMessage('label.referralCode') },
        { component: CreatePasswordForm, title: localeHelper.getMessage('label.createPassword'), props: { title: 'Create Password' } },
        { component: AccountCreationSuccessful, title: localeHelper.getMessage('label.accountCreationSuccessful') },
        { component: ReferrerSignupSuccessful }
      ]
    }
  },

  created() {
    // signup form for referral link
    if (this.referrer) {
      this.formSteps[0].props = { referrer: true }
      this.formSteps[3].props = { referrer: true }
      this.formSteps.splice(2, 1)
      this.formSteps.splice(2, 1)
      this.formSteps.splice(3, 1)
    } else {
      this.formSteps.splice(2, 1)
    }
  },

  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(val) {
        this.currentStep = 0
        this.$emit('input', val)
      }
    },

    currentTitle() {
      return this.formSteps[this.currentStep].title
    },

    referrer() {
      return this.$route.query.referralCode && this.$route.query.referralCode.length > 0
    }
  },

  methods: {
    close() {
      this.$nextTick(() => {
        const defaultForm = {
          name: '',
          mobileNumber: '',
          email: '',
          referralCode: ''
        }
        this.form = { ...defaultForm }
      })
      if (this.$route.query.referralCode) this.$router.replace('/home')
      this.$emit('input', false)
    },

    onNextStep() {
      if (this.currentStep === this.formSteps.length - 1) {
        this.currentStep = 0
        this.maxWidth = '450'
        this.close()
        return
      }
      if (this.referrer && this.currentStep === this.formSteps.length - 2) {
        this.maxWidth = '600'
      }
      if (!this.referrer && this.currentStep === this.formSteps.length - 2 && this.$vuetify.breakpoint.mdAndUp) {
        this.maxWidth = '600'
      }

      this.currentStep++
    },

    onPrevStep() {
      if (this.currentStep > 0) this.currentStep--
    },
    closeSignUpDialog() {
      if (this.$route.query.referralCode || this.$route.hash) this.$router.replace({ name: this.$constants.ROUTE_NAME.HOME })
      location.reload()
    }
  }
}
</script>
